/* eslint-disable no-undef */
define([], () => {
  'use strict';
  const CONFIG = {
    'analytics': {
      'api': `${ENVS_API_HOST}/instrumentation-svc`
    },
    'two': {
      'open_panel_on_load': 'true'
    },
    'sim': {
      'api': `${ENVS_API_HOST}${ENVS_API_PATH}/sim`
    },
    'hvx': {
      'poitype': {
        'nursing_home': 'POI-NursingHome-g.svg',
        'shelter': 'POI-Shelter-g.svg',
        'industrial_plant': 'POI-Industrial-Plant-g.svg',
        'electrical_substation': 'POI-ElectricalSubstation-g.svg',
        'police_station': 'POI-Police-g.svg',
        'wwtp': 'POI-WWTP-g.svg',
        'heliport': 'POI-Heliport-g.svg',
        'airport': 'POI-Airport-g.svg',
        'landfill': 'POI-Landfill-g.svg',
        'school': 'POI-School-g.svg',
        'eoc': 'POI-EOC-g.svg',
        'train_station': 'POI-Train-Station-g.svg',
        'debris': 'POI-Debris-Staging-Area-g.svg',
        'fire': 'POI-Fire-g.svg',
        'bridge': 'POI-Bridge.svg',
        'power': {
          'gas': 'POI-Power-Gas-g.svg',
          'coal': 'POI-Power-Coal-g.svg',
          'nuclear': 'POI-Power-Nuclear-g.svg',
          'generic': 'POI-Power-Generic-g.svg'
        },
        'hospital': 'POI-Hospital-g.svg',
        'military_base': 'POI-Military-Base-g.svg'
      },
      'experimentalFeatures': 'true',
      'experimental': {
        'rainrivertide': 'false',
        'zonebasedanalytic': 'false',
        'stormsim': 'true',
        'hes': 'false',
        'riskprofile': 'false',
        'leav': 'false',
        'medicareelectricitydm': 'false',
        'zonebasedimpact': 'false',
        'wind': 'false'
      },
      'api': `${ENVS_API_HOST}${ENVS_API_PATH}`,
      'notify': `${ENVS_NOTIFY_HOST}${ENVS_NOTIFY_PATH}`,
      'mapserver': ENVS_MAPSERVER_HOST,
    },
    
  };
  return function Config(eventManager){
    let config = {};
        
    const configLoadedEvt = 'hvx.config.loaded';
        
    function bindEvent(){
      eventManager.addListener('config', loadData);
    }
        
    function loadData(remoteConfig={}){
      config = CONFIG;
      Object.assign(config, remoteConfig);
      //console.log(config);
      deepFreeze(config);
      eventManager.fireEvent(configLoadedEvt, config);
    }
        
    function deepFreeze(o) {
      let prop, propKey;
      Object.freeze(o); // First freeze the object.
      for (propKey in o) {
        prop = o[propKey];
        if (!o.hasOwnProperty(propKey) || !(typeof prop === 'object') || Object.isFrozen(prop)) {
          // If the object is on the prototype, not an object, or is already frozen,
          // skip it. Note that this might leave an unfrozen reference somewhere in the
          // object if there is an already frozen object containing an unfrozen object.
          continue;
        }

        deepFreeze(prop); // Recursively call deepFreeze.
      }
    }
        
    return {
      CONFIG_LOADED: configLoadedEvt,
            
      init: function(){
        bindEvent();
      },

      // eslint-disable-next-line no-unused-vars
      httpLoad: async function(opt_url){
        const result = await fetch(opt_url || `${ENVS_NOTIFY_HOST}${ENVS_NOTIFY_PATH}/hvxconfig`);
        if (!result.ok) {
          console.debug('Failed to load hvx configuration:', result.statusText);
          return;
        }
        const remoteConfig = await result.json();

        loadData(remoteConfig);
        // },
        // failure: function(response){
        //   console.debug('Failed to load hvx configuration:', response);
        // }
        // });
      },

      getProperty: function(key){
        const keys = key.split('.');

        if (!config)
          config = {};
        let value = config[keys[0]];
        for(let i=1; i<keys.length; i++){
          if(value != null){
            value = value[keys[i]];
          }else{
            return null;
          }
        }
        return value;
      }
    };
  };
    
});
